<div *ngIf="role==='Administrator'">
  <aside
  class="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered ">
  <a class="container pe-8" aria-label="Front">
    <div class="d-flex justify-content-end">
      <button class="navbar-toggler me-3 " type="button" (click)="toggleColumnLayout()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="row ">
      <div class="col-lg-12 text-center">
        <a class="navbar-brand flex-cloumn " routerLink="/">
          <img src="../../../assets/images/DumyUser/touch.png" alt="" style="height: 60px" class="mt-2" />
          <div class="d-flex">
            <h6 class="pt-1 h2 me-2">Touch</h6> <h6 class="h2 pt-1" style="color: rgb(129,41,217);">Connect</h6>
          </div>
        </a>
      </div>

    </div>
  </a>
  <div class="navbar-vertical-container">
    <div class="navbar-vertical-footer-offset">
      <div class="navbar-vertical-content">
        <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/ManueDash')" routerLink="/ManueDash">
              <div class="d-flex justify-content-between">
                <i class="pi pi-objects-column u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'manue' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/Admin')" routerLink="/Admin">
              <div class="d-flex justify-content-between">
                <i class="pi pi-microsoft u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'dashboard' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/touchConnect')" routerLink="/touchConnect">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-bars u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'links' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li> -->
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/UserInterestManu')" routerLink="/UserInterestManu">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-magnet u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userInterests' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/userContacts')" routerLink="/userContacts">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-address-book u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userContacts' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
         
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/bussinessLeadPage')" routerLink="/bussinessLeadPage">
              <div class="d-flex justify-content-between">
                <i class="fas fa-briefcase u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessLeads' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/BusinessInsights')" routerLink="/BusinessInsights">
              <div class="d-flex justify-content-between">
                <i class="fas fa-chart-line u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessInsights' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/EconomicAssistance')" routerLink="/EconomicAssistance">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-wand-magic-sparkles u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'aiAssistance' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/EconimicNews')" routerLink="/EconimicNews">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-shekel-sign u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark "> {{'MENU.ECONOMIC_NEWS' | translate}}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
         
          
          <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navSetting">
            <a [ngClass]="getClassForRoute('/setting')" routerLink="/setting">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-gear u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'setting' | translate }}</span>
                <i class="pt-1 text-white"></i>
              </div>
            </a>
          </li>
           -->
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/NotificationSettingsManue')" routerLink="/NotificationSettingsManue">
              <div class="d-flex justify-content-between">
                <i class="pi pi-cog text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'notificationAlerts' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
         
         
      
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/AccountSetting')" routerLink="/AccountSetting">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Account Setting' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/DeleteMyAccount')" routerLink="/DeleteMyAccount">
              <div class="d-flex justify-content-between">
                <i class="pi pi-trash text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'DeleteMyAccount' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/sitesetting')" routerLink="/sitesetting">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Menu Admin' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          <li class="nav-item u-sidebar-nav-menu__item d-grid" id="navProfile">
            <a class="btn btn-primary mt-2 " (click)="logut()">
              <div class="d-flex justify-content-between">
                <i class="bi bi-box-arrow-left u-sidebar-nav-menu__item-icon text-white" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title pt-2">{{ 'Logout' | translate }}</span>
              </div>
            </a>
          </li>
          

        </div>
      </div>

    </div>
  </div>
</aside>


</div>

<div *ngIf="role!=='Administrator'">
  <aside
  class="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered ">
  <a class="container pe-8" aria-label="Front">
    <div class="d-flex justify-content-end">
      <button class="navbar-toggler me-3 " type="button" (click)="toggleColumnLayout()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="row ">
      <div class="col-lg-12 text-center">
        <a class="navbar-brand flex-cloumn " routerLink="/">
          <img src="../../../assets/images/DumyUser/touch.png" alt="" style="height: 60px" class="mt-2" />
          <div class="d-flex">
            <h6 class="pt-1 h2 me-2">Touch</h6> <h6 class="h2 pt-1" style="color: rgb(129,41,217);">Connect</h6>
          </div>
        </a>
      </div>

    </div>
  </a>
  <div class="navbar-vertical-container">
    <div class="navbar-vertical-footer-offset">
      <div class="navbar-vertical-content">
        <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/ManueDash')" routerLink="/ManueDash">
              <div class="d-flex justify-content-between">
                <i class="pi pi-objects-column u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'manue' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          
          
          <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/touchConnect')" routerLink="/touchConnect">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-bars u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'links' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li> -->
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/UserInterestManu')" routerLink="/UserInterestManu">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-magnet u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userInterests' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/userContacts')" routerLink="/userContacts">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-address-book u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userContacts' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
         
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/bussinessLeadPage')" routerLink="/bussinessLeadPage">
              <div class="d-flex justify-content-between">
                <i class="fas fa-briefcase u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessLeads' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/BusinessInsights')" routerLink="/BusinessInsights">
              <div class="d-flex justify-content-between">
                <i class="fas fa-chart-line u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessInsights' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/EconomicAssistance')" routerLink="/EconomicAssistance">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-wand-magic-sparkles u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'aiAssistance' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/EconimicNews')" routerLink="/EconimicNews">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-shekel-sign u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark "> {{'MENU.ECONOMIC_NEWS' | translate}}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          
         
          
          <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navSetting">
            <a [ngClass]="getClassForRoute('/setting')" routerLink="/setting">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-gear u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'setting' | translate }}</span>
                <i class="pt-1 text-white"></i>
              </div>
            </a>
          </li>
           -->
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/NotificationSettingsManue')" routerLink="/NotificationSettingsManue">
              <div class="d-flex justify-content-between">
                <i class="pi pi-cog text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'notificationAlerts' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
         
         
      
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/AccountSetting')" routerLink="/AccountSetting">
              <div class="d-flex justify-content-between">
                <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Account Setting' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
          <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
            <a [ngClass]="getClassForRoute('/DeleteMyAccount')" routerLink="/DeleteMyAccount">
              <div class="d-flex justify-content-between">
                <i class="pi pi-trash text-dark" style="font-size:18px;"></i>
                <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'DeleteMyAccount' | translate }}</span>
                <i class=" pt-1 text-white"></i>
              </div>
            </a>
          </li>
         
          <li class="nav-item u-sidebar-nav-menu__item d-grid" id="navProfile">
            <a class="btn btn-primary mt-2 " (click)="logut()">
              <div class="d-flex justify-content-between">
                <i class="bi bi-box-arrow-left u-sidebar-nav-menu__item-icon text-white" style="font-size: 20px;"></i>
                <span class="u-sidebar-nav-menu__item-title pt-2">{{ 'Logout' | translate }}</span>
              </div>
            </a>
          </li>
          

        </div>
      </div>

    </div>
  </div>
</aside>


</div>








